import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MissingTranslationHandler,
  TranslateDefaultParser,
  TranslateLoader,
  TranslateModule,
  TranslateParser,
} from '@ngx-translate/core';
import { ClipboardModule } from 'ngx-clipboard';

// Components
import { AppComponent } from './app.component';

// Modules
import { AppRoutingModule } from './app-routing.module';
import { MortgageModule } from './mortgage/mortgage.module';
import { PreSimulatorModule } from './pre-simulator/pre-simulator.module';
import { SharedModule } from './shared/shared.module';
import { i18nService } from './vass-core/services/i18n.service';
import { VassCoreModule } from './vass-core/vass-core.module';

import { registerLocaleData } from '@angular/common';
import localeEsEs from '@angular/common/locales/es';
import { CustomTranslateLoader } from './shared/utils/CustomTranslateLoader';
import { CustomMissingTranslationHandler } from './shared/utils/custom-missing-translation-handler';

export function customLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

registerLocaleData(localeEsEs, 'es');
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    ClipboardModule,
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: customLoaderFactory,
        deps: [HttpClient],
        useClass: CustomTranslateLoader,
      },
      parser: {
        provide: TranslateParser,
        useClass: TranslateDefaultParser,
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
    }),
    SharedModule.forRoot(),
    AppRoutingModule,
    VassCoreModule,
    MortgageModule.forRoot(),
    PreSimulatorModule.forRoot(),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    i18nService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
